import {BaseModel} from "../models/base-model";

export class BaseService extends BaseModel {
  static injectables = [];

  isInstanceOf(type) {
    return this instanceof type;
  }
}
